import React from 'react';
import {
  Sun,
  CloudSun,
  CloudFog,
  CloudDrizzle,
  CloudRain,
  CloudSnow,
  CloudLightning,
  Cloud,
  type LucideIcon,
} from 'lucide-react';
import { weatherSfToLucide } from '../../utils/weatherIcons';

const LUCIDE_MAP: Record<string, LucideIcon> = {
  Sun,
  CloudSun,
  CloudFog,
  CloudDrizzle,
  CloudRain,
  CloudSnow,
  CloudLightning,
  Cloud,
};

export interface WeatherConditionIconProps {
  iconName: string;
  dimmed?: boolean;
  size?: number;
  className?: string;
}

const WeatherConditionIcon: React.FC<WeatherConditionIconProps> = ({
  iconName,
  dimmed = false,
  size = 20,
  className,
}) => {
  const lucideName = weatherSfToLucide(iconName);
  const Icon = LUCIDE_MAP[lucideName] ?? Cloud;

  return (
    <Icon
      size={size}
      className={className}
      aria-hidden
      style={dimmed ? { opacity: 0.55 } : undefined}
    />
  );
};

export default WeatherConditionIcon;
